import {
    AbilityBuilder,
} from '@casl/ability'

const allRights = ['read', 'write', 'delete', 'writeComment', 'openWriteModal']
const ordersRights = ['read', 'write', 'writeComment']
const limitedRights = ['read']

const partnerOrdersRights = ['read', 'writeComment']
const requestsRight = ['read', 'write']

export function ability(type) {
    return AbilityBuilder.define((can) => {
        switch (type) {
        case 'super-admin':
            can(allRights, 'Admin')
            can(allRights, 'Calendar')
            can(allRights, 'Engineers')
            can(allRights, 'Masters')
            can(allRights, 'Clients')
            can(allRights, 'Partners')
            can(allRights, 'Chat')
            can(allRights, 'Orders')
            can(allRights, 'Requests')
            can(allRights, 'Services')
            can(allRights, 'Administrators')
            can(allRights, 'Materials')
            can(allRights, 'Problems')
            can(allRights, 'Tags')
            can(allRights, 'PDF')
            can(allRights, 'Offices')
            break

        case 'technical-admin':
            can(allRights, 'Admin')
            can(allRights, 'Calendar')
            can(allRights, 'Engineers')
            can(allRights, 'Masters')
            can(allRights, 'Clients')
            can(allRights, 'Partners')
            can(allRights, 'Orders')
            can(allRights, 'Requests')
            can(allRights, 'Services')
            can(allRights, 'Administrators')
            can(allRights, 'Materials')
            can(allRights, 'Problems')
            can(allRights, 'Tags')
            can(allRights, 'PDF')
            can(allRights, 'Offices')
            break

        case 'advanced-admin':
            can(allRights, 'Admin')
            can(allRights, 'Calendar')
            can(allRights, 'Engineers')
            can(allRights, 'Masters')
            can(allRights, 'Clients')
            can(allRights, 'Partners')
            can(allRights, 'Chat')
            can(allRights, 'Orders')
            can(allRights, 'Requests')
            can(allRights, 'Services')
            can(allRights, 'Materials')
            can(allRights, 'Problems')
            can(allRights, 'Tags')
            can(allRights, 'PDF')
            can(allRights, 'Offices')
            break

        case 'normal-admin':
            can(allRights, 'Admin')
            can(limitedRights, 'Calendar')
            can(limitedRights, 'Engineers')
            can(limitedRights, 'Masters')
            can(limitedRights, 'Clients')
            can(limitedRights, 'Partners')
            can(allRights, 'Chat')
            can(ordersRights, 'Orders')
            can(requestsRight, 'Requests')
            can(limitedRights, 'Services')
            can(limitedRights, 'Materials')
            can(limitedRights, 'Problems')
            can(limitedRights, 'Tags')
            can(limitedRights, 'PDF')
            can(limitedRights, 'Offices')
            break

        case 'partner-admin':
            can(allRights, 'Admin')
            can(limitedRights, 'Calendar')
            can(['read', 'openWriteModal'], 'Engineers')
            can(['read', 'openWriteModal'], 'Masters')
            can(limitedRights, 'Clients')
            can(partnerOrdersRights, 'Orders')
            can(limitedRights, 'Services')
            can(limitedRights, 'Materials')
            can(limitedRights, 'Problems')
            can(limitedRights, 'Tags')
            can(limitedRights, 'PDF')
            break
        default:
            break
        }
    })
}
